<template>
  <div class="settingsform">
    <modal identifier="leaveeditquestion" ref="question" :question="question" :cancelText="cancelText" :confirmText="confirmText" :showTrigger="false"  v-on:onConfirm="okClicked()" v-on:onCancel="cancelClicked()" confirmButtonClass="green"/>
    <ul class="collapsible" v-if="role != null">
      <li>
          <div class="collapsible-header">{{$t('bases.pests')}} <i class="material-icons">expand_more</i></div>
          <pests :role="role" ref="pestsview" :extended_privileges="extended_privileges"/>
      </li>
      <li>
        <div class="collapsible-header">{{$t('bases.substances')}} <i class="material-icons">expand_more</i></div>
        <substances :role="role" ref="substancesview" :extended_privileges="extended_privileges"/>
      </li>
       <li v-if="role != 'ddd_customer'">
        <div class="collapsible-header">{{$t('bases.device_categories')}} <i class="material-icons">expand_more</i></div>
        <devicecategories :role="role" ref="devcatsview" :extended_privileges="extended_privileges"/>
      </li>
      <li v-if="role != 'ddd_customer'">
        <div class="collapsible-header">{{$t('bases.devtypes')}}<i class="material-icons">expand_more</i></div>
        <devtypes :role="role" ref="devtypesview" :extended_privileges="extended_privileges"/>
      </li>
      <li v-if="role != 'ddd_customer'">
        <div class="collapsible-header">{{$t('bases.materials')}}<i class="material-icons">expand_more</i></div>
        <materials :role="role" ref="materialsview" :extended_privileges="extended_privileges"/>
      </li>
      <li v-if="role != 'ddd_customer'">
        <div class="collapsible-header">{{$t('bases.workers')}}<i class="material-icons">expand_more</i></div>
        <workers :role="role" ref="workersview" :extended_privileges="extended_privileges"/>
      </li>
      <li v-if="role != 'ddd_customer'">
        <div class="collapsible-header">{{$t('bases.codes')}}<i class="material-icons">expand_more</i></div>
        <tranches :role="role" :extended_privileges="extended_privileges"/>
     </li>
      <li v-if="role != 'ddd_customer'">
        <div class="collapsible-header">{{$t('bases.maintenaces')}}<i class="material-icons">expand_more</i></div>
        <maintenaces :role="role" :extended_privileges="extended_privileges"/>
     </li>
      <li v-if="role == 'ddd_customer'">
        <div class="collapsible-header">{{$t('bases.documents')}}<i class="material-icons">expand_more</i></div>
        <documents/>
     </li>
    </ul>
  </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';

export default {
  data: function () {
    return {
      question: "",
      cancelText: "",
      confirmText: ""
    }
  },
  props: { role: String, extended_privileges: Boolean },
  beforeRouteLeave (to, from , next) {
    if(this.role != 'ddd_customer'){
      if(
        this.$refs.pestsview.anyEdited() || this.$refs.substancesview.anyEdited() || 
        this.$refs.devcatsview.anyEdited() || this.$refs.devtypesview.anyEdited() || 
        this.$refs.materialsview.anyEdited() || this.$refs.workersview.anyEdited()){
          this.question = this.$t('menu.save_question');
          this.cancelText = this.$t('menu.buttons.save_cancel')
          this.confirmText = this.$t('menu.buttons.save_changes')
          this.$refs.question.open();
          this.callback = next;
      }else{
        next()
      }
    }else{
      next()
    }
  },
  created() {
  },
   mounted() {
    var elems = document.querySelectorAll('.collapsible');
    var instances = M.Collapsible.init(elems, { accordion: true });
  },
  methods: {
    cancelClicked(){
      this.callback();
    },
    okClicked(){
      
    }
},
computed: {
},
mixins: [Vue2Filters.mixin],
}
</script>

<style scoped>
.settingsform{
  padding-top: 15px;
}
.login_button{
  color: red;
}
p {
  font-size: 2em;
  text-align: center;
}
.selectorignored select{
    display: block;
}
.formul .row .col{
  padding-bottom: 15px;
}
.formul .s12 .input-field {
  width: 90%
}
.formul .s4 .input-field {
  width: 60%
}
.formul .s6 .input-field {
  width: 60%
}
.input-field{
  margin: 0px !important;
}
.settingsform > .row {
  margin-bottom: 0px;
}
.settingsform > .row > .collapsible {
  margin-bottom: 0px;
}
.settingsform .btn-large {
  border-radius: 8px;
  background-color: white;
  color: black;
  border-color: #00CC66;
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/deep/ .collapsible-header{
  background-color: #8A8D91;
  text-transform: uppercase;
}
.collapsible-body .collapsible-header{
  background-color: #FFF;
  text-transform: initial;
}
.collapsible-body .collapsible-header .row{
      margin-bottom: 0px;
}
.collapsible-body .collapsible-body.formul{
  background-color: #FFF;
  margin-top: 5px;
  border-bottom-style: solid;
  border-bottom-width: 5px;
}
.collapsible-body{
  border-bottom: 0px;
}
.baseheader{
  background-color: #DADADA;
  margin-bottom: 0px;
}
.collapsible{

  margin-left: 15px;
  margin-right: 15px;
  box-shadow: 0 0px 0px;
  border: 0px;
}
.collapsible li{
  padding-bottom: 15px;
}
.settingsform .btn-large {
  border-radius: 8px;
  background-color: white;
  color: black;
  border-color: #00CC66;
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.solidgreen {
   background-color: #00CC66 !important;
   color: black;
}
.active > .reded{
  border-color: rgb(194, 32, 38);
  border: 4px solid rgb(194, 32, 38);
}
.settingsform .btn-large {
  border-radius: 8px;
  background-color: white;
  color: black;
  border-color: #00CC66;
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.inline > select{
  display: block !important;
}

.collapsible-body {
  padding: 1em;
  padding-right: 0em;
  padding-left: 1em;
  }
.collapsible li.active .collapsible-header{
  background-color: #C22026;
}

.collapsible li i {
  position: absolute;
  right: 15px;
}
.collapsible li.active i {
  -ms-transform: rotate(180deg); /* IE 9 */
  -webkit-transform: rotate(180deg); /* Chrome, Safari, Opera */
  transform: rotate(180deg);
}
.input-field{
  margin-top: 0rem;
  margin-bottom: 0rem;
}
.btn-small {
    color: black;
    border-radius: 8px;
}
/deep/ input:disabled, /deep/ textarea:disabled, /deep/ select:disabled{
  color: black !important;
  opacity: 1;
}
/deep/ .input-field.inline input, .input-field.inline .select-dropdown{
  margin-bottom: 5px;
}
/deep/ .rightlabel {
    line-height: 2 !important;
}
/deep/ .rightlabel {
    text-align: right;
    line-height: 2 !important;
}
/deep/ input[type="file"]{
    max-width: 100%;
}
/deep/ [type="checkbox"]:not(:checked):disabled+span:not(.lever):before {
    border: solid 2px;
    background-color: rgba(0,0,0,0.15);
}
/deep/ input[type='checkbox']{
    display: none;
}
/deep/ .cancelbutton {
    border: solid 2px;
    border-radius: 8px;
}
/deep/ tr th {
  text-transform: uppercase;
}
</style>
